import moment from 'moment';

export function formatDate(value, format = 'DD.MM.YYYY') {
    if (!value) return '';
    return moment(value).format(format);
}

export function formatTime(value) {
    if (!value) return '';

    if (value instanceof Date) {
        return moment(value).format("HH:mm");
    }
    if (value.length == 19) {
        return moment(new Date(value)).format("HH:mm");
    }

    return value.slice(0, -3);
}